/**
 * components/hazard/inspectionFlow.js — ҮЗЛЭГИЙН ТӨРӨЛ → ЯМАР ХУУДАС НЭЭХ ВЭ.
 *
 * ⚠ hse_mobile/src/utils/inspectionFlow.ts-ийн ХОС. Хоёр тал ЯГ ИЖИЛ байх
 *   ёстой — зөрвөл нэг хэрэглэгч вэб дээр нэг хуудас, утсан дээр өөр хуудас
 *   бөглөнө. Мобайл тал нь тесттэй:
 *       cd hse_mobile && node scripts/test-inspection-flow.js
 *
 * ЖУРМЫН ҮНДЭСЛЭЛ (ХЭМАБМТ-06):
 *   I-IV шат нь ЗӨВХӨН «Шат шатны үзлэг»-ийн дараалал бөгөөд тус бүр тогтсон
 *   маягттай (Хавсралт №2-5). Харин ЗОРИЛТОТ хяналтын маягтыг журам
 *   «Удирдамжаар», ЭЭЛЖИТ БУС хяналтынхыг «—» (тогтсон маягтгүй) гэж заасан
 *   тул эдгээрийн шалгах асуудал нь дугаарын шатнаас БИШ, УДИРДАМЖААС ирнэ.
 */
import { loadStages, stageFullLabel } from "src/components/inspection/stageRef";


/**
 * xab.inspection_type.code → xab.inspection_stage.code
 *
 * `planned` (Төлөвлөгөөт) энд ОРООГҮЙ нь санаатай: төлөвлөгөөт шалгалт нь
 * зорилтот ч, ээлжит бус ч байж болно. Тиймээс шатыг ТОГТООХГҮЙ — хэрэглэгч
 * шалгалт эхлүүлэх цонхон дотроос эрхийнхээ хүрээнд сонгоно.
 */
export const DIRECTIVE_STAGE_OF_TYPE = {
  targeted: "targeted",
  by_directive: "targeted",
  bn_directive: "targeted",
  // Журмын 1.5.3 — байнгын хяналт (мониторинг) нь бие даасан ТӨРӨЛ.
  // Өмнө нь энэ зураглалд огт байгаагүй тул мониторингоор бүртгэсэн
  // зөрчил шатгүй үлддэг байв.
  monitoring: "monitoring",
  unplanned: "irregular",
};

/* ⚠ Нөөц утга. Лавлах (`xab.inspection_stage`) татагдмагц ДООРХ
   subscriber нь эдгээрийг лавлахын БҮТЭН нэрээр дардаг — 3 газарт
   `DIRECTIVE_STAGE_LABEL[x]` гэж хэрэглэдэг тул дуудагчид хөндөх
   шаардлагагүй. */
export const DIRECTIVE_STAGE_LABEL = {
  targeted: "Зорилтот хяналт",
  irregular: "Ээлжит бус хяналт",
  monitoring: "Байнгын хяналт (мониторинг)",
};

loadStages().then(() => {
  Object.keys(DIRECTIVE_STAGE_LABEL).forEach((code) => {
    const v = stageFullLabel(code);
    if (v) DIRECTIVE_STAGE_LABEL[code] = v;
  });
});

/** Дугаарласан шат (1-4) → ХЭМАБМТ-06-ийн шатны код. */
export const STAGE_OF_LEVEL = { 1: "I", 2: "II", 3: "III", 4: "IV" };

const HIDDEN = {
  visible: false,
  showLevels: false,
  directiveStage: null,
  fixedStage: null,
  sectionTitle: "",
  needsLevel: false,
};

/**
 * Сонгосон үзлэгийн төрөл (ба шат)-д тохирох урсгалыг тодорхойлно.
 *
 * @param {string|null} inspectionType xab.inspection_type.code
 * @param {number|null} level          сонгосон дугаарын шат (1-4)
 * @returns {{visible:boolean, showLevels:boolean, directiveStage:string|null,
 *            fixedStage:string|null, sectionTitle:string, needsLevel:boolean}}
 */
export function inspectionFlowFor(inspectionType, level) {
  // Төрөл сонгоогүй — хоосон хэсэг гаргахгүй
  if (!inspectionType) return HIDDEN;
  // «Чухал хяналт» нь 15 критик хяналтын шалгах хуудсаараа явдаг тул
  // үзлэгийн ШАТ огт хамаарахгүй (хуудас нь Үзлэгийн төрөл хэсэгт гарна).
  if (inspectionType === "critical_control") return HIDDEN;

  const directiveStage = DIRECTIVE_STAGE_OF_TYPE[inspectionType] || null;
  const showLevels = inspectionType === "level_by_level";

  return {
    visible: true,
    showLevels,
    directiveStage,
    fixedStage: showLevels
      ? level
        ? STAGE_OF_LEVEL[level] || null
        : null
      : directiveStage,
    sectionTitle: showLevels ? "Үзлэгийн шат" : "Шалгах хуудас",
    // ⚠ Шат сонгуулахгүй байж «шатаа сонго» гэж шалгах нь ЛОГИКИЙН АЛДАА —
    //   1-4 товч харагдахгүй үед хэрэглэгч засах ямар ч аргагүй болно.
    needsLevel: showLevels,
  };
}
